module.exports = __webpack_public_path__ + "img/concrete-hole-decal-26.07fb043c.png";